import { handleResponseErr } from 'utils/apiHelperUtils'
import { Toastr } from 'components/global/Toastr'

const DEFAULT_STATE = {
  cut_off_day: {},
  show_decimal_points: {},
  overtime_calculation: {},
  delay_calculation: {},
  delay_calculation_fetching: {},
  absence_calculation: {},
  absence_calculation_fetching: false,
  vacation_calculation: {},
  unpaid_calculation: {},
  xero_configuration: {},
  is_delay_deduction_applicable: {},
  payrun_configuration: {},
  bulk_payrun_configurations: [],
  sending_payslip_enabled: {},
  loan_limit: {},
  errMsg: null,
  succMsg: null,
  fetching: false,
  gosi_configuration: {},
  loading: false,
  overtime_fetching: false,
}

let changes = null
export default function configurationReducer(state = DEFAULT_STATE, action) {
  const { payload } = action
  switch (action.type) {
    case 'CUT_OFF_DAY_LOAD_PENDING':
    case 'IS_GOSI_ENABLED_LOAD_PENDING':
    case 'SHOW_DECIMAL_POINTS_LOAD_PENDING':
    case 'IS_PENDING_PAY_PAYSLIP_LOAD_PENDING':
    case 'VACATION_CALCULATION_LOAD_PENDING':
    case 'VACATION_CALCULATION_UPDATE_PENDING':
    case 'UNPAID_CALCULATION_LOAD_PENDING':
    case 'UNPAID_CALCULATION_UPDATE_PENDING':
    case 'XERO_CONFIGURATION_LOAD_PENDING':
    case 'IS_GOSI_ENABLED_UPDATE_PENDING':
    case 'IS_DELAY_DEDUCTION_APPLICABLE_LOAD_PENDING':
      return {
        ...state,
        fetching: true,
        errMsg: null,
        succMsg: null,
        loading: !state?.cut_off_day?.value || !state?.show_decimal_points?.value,
      }

    case 'OVERTIME_CALCULATION_LOAD_PENDING':
    case 'OVERTIME_CALCULATION_UPDATE_PENDING':
      return {
        ...state,
        overtime_fetching: true,
        errMsg: null,
        succMsg: null,
      }

    case 'ABSENCE_CALCULATION_UPDATE_PENDING':
    case 'ABSENCE_CALCULATION_LOAD_PENDING':
      return {
        ...state,
        absence_calculation_fetching: true,
      }

    case 'DELAY_CALCULATION_LOAD_PENDING':
    case 'DELAY_CALCULATION_UPDATE_PENDING':
      return {
        ...state,
        delay_calculation_fetching: true,
      }

    case 'LOAN_LIMIT_LOAD_PENDING':
    case 'IS_DELAY_DEDUCTION_APPLICABLE_UPDATE_PENDING': {
      return {
        ...state,
        fetching: true,
        errMsg: null,
        succMsg: null,
        loading: !state.loan_limit.value,
      }
    }
    case 'CUT_OFF_DAY_UPDATE_PENDING':
    case 'SHOW_DECIMAL_POINTS_UPDATE_PENDING':
    case 'SHOW_DECIMAL_POINTS_UPDAT_PENDING':
    case 'IS_PENDING_PAY_PAYSLIP_UPDATE_PENDING':
    case 'LOAN_LIMIT_UPDATE_PENDING':
    case 'LOAN_LIMIT_BULK_UPDATE_PENDING':
      return {
        ...state,
        fetching: true,
        errMsg: null,
        succMsg: null,
        loading: true,
      }

    case 'OVERTIME_CALCULATION_LOAD_REJECTED':
    case 'OVERTIME_CALCULATION_UPDATE_REJECTED':
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        overtime_fetching: false,
      }

    case 'CUT_OFF_DAY_LOAD_REJECTED':
    case 'IS_GOSI_ENABLED_LOAD_REJECTED':
    case 'CUT_OFF_DAY_UPDATE_REJECTED':
    case 'SHOW_DECIMAL_POINTS_LOAD_REJECTED':
    case 'SHOW_DECIMAL_POINTS_UPDATE_REJECTED':
    case 'IS_PENDING_PAY_PAYSLIP_UPDATE_REJECTED':
    case 'IS_PENDING_PAY_PAYSLIP_LOAD_REJECTED':
    case 'DELAY_CALCULATION_LOAD_REJECTED':
    case 'DELAY_CALCULATION_UPDATE_REJECTED':
    case 'ABSENCE_CALCULATION_LOAD_REJECTED':
    case 'ABSENCE_CALCULATION_UPDATE_REJECTED':
    case 'VACATION_CALCULATION_LOAD_REJECTED':
    case 'VACATION_CALCULATION_UPDATE_REJECTED':
    case 'UNPAID_CALCULATION_LOAD_REJECTED':
    case 'UNPAID_CALCULATION_UPDATE_REJECTED':
    case 'LOAN_LIMIT_LOAD_REJECTED':
    case 'LOAN_LIMIT_UPDATE_REJECTED':
    case 'LOAN_LIMIT_BULK_UPDATE_REJECTED':
    case 'XERO_CONFIGURATION_UPDATE_REJECTED':
    case 'IS_GOSI_ENABLED_UPDATE_REJECTED':
      Toastr.error(handleResponseErr(action.payload))
      changes = {
        errMsg: handleResponseErr(payload),
        fetching: false,
        loading: false,
        delay_calculation_fetching: false,
        absence_calculation_fetching: false,
      }
      return { ...state, ...changes }

    case 'CUT_OFF_DAY_LOAD_FULFILLED':
    case 'CUT_OFF_DAY_UPDATE_FULFILLED':
      if (action.payload.data.message) {
        Toastr.success(action.payload.data.message)
      }
      changes = {
        cut_off_day: payload.data.data.payschedule,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }

    case 'IS_GOSI_ENABLED_LOAD_FULFILLED':
    case 'IS_GOSI_ENABLED_UPDATE_FULFILLED':
      if (action.payload.data.message) {
        Toastr.success(action.payload.data.message)
      }
      return {
        ...state,
        fetching: false,
        loading: false,
        errMsg: null,
        succMsg: payload.data.message,
        gosi_configuration: payload.data.data.payrun_configuration,
      }
    case 'IS_PENDING_PAY_PAYSLIP_UPDATE_FULFILLED':
      if (action.payload.data.message) {
        Toastr.success(action.payload.data.message)
      }
      return {
        ...state,
        fetching: false,
        loading: false,
        errMsg: null,
        succMsg: payload.data.message,
        sending_payslip_enabled: payload.data.data.payrun_configuration,
      }
    case 'IS_PENDING_PAY_PAYSLIP_LOAD_FULFILLED':
      return {
        ...state,
        fetching: false,
        loading: false,
        errMsg: null,
        succMsg: payload.data.message,
        sending_payslip_enabled: payload.data.data.payrun_configuration,
      }

    case 'XERO_CONFIGURATION_LOAD_FULFILLED':
    case 'XERO_CONFIGURATION_UPDATE_FULFILLED':
      if (action.payload.data.message) {
        Toastr.success(action.payload.data.message)
      }
      changes = {
        xero_configuration: payload.data.data.organization_configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }

    case 'SHOW_DECIMAL_POINTS_LOAD_FULFILLED':
    case 'SHOW_DECIMAL_POINTS_UPDATE_FULFILLED':
      changes = {
        show_decimal_points: payload.data.data.organization_configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }

    case 'OVERTIME_CALCULATION_LOAD_FULFILLED':
    case 'OVERTIME_CALCULATION_UPDATE_FULFILLED':
      if (action.payload.data.message) {
        Toastr.success(action.payload.data.message)
      }
      changes = {
        overtime_calculation: payload.data.data.payrun_configuration,
        succMsg: payload.data.message,
        overtime_fetching: false,
        errMsg: null,
      }
      return { ...state, ...changes }

    case 'DELAY_CALCULATION_LOAD_FULFILLED':
    case 'DELAY_CALCULATION_UPDATE_FULFILLED':
      if (action.payload.data.message) {
        Toastr.success(action.payload.data.message)
      }
      changes = {
        delay_calculation: payload.data.data.payrun_configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
        delay_calculation_fetching: false,
      }
      return { ...state, ...changes }

    case 'IS_DELAY_DEDUCTION_APPLICABLE_LOAD_FULFILLED':
    case 'IS_DELAY_DEDUCTION_APPLICABLE_UPDATE_FULFILLED':
      if (action.payload.data.message) {
        Toastr.success(action.payload.data.message)
      }
      changes = {
        is_delay_deduction_applicable: payload.data.data.payrun_configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }

    case 'IS_ABSENCE_DEDUCTION_APPLICABLE_LOAD_FULFILLED':
    case 'IS_ABSENCE_DEDUCTION_APPLICABLE_UPDATE_FULFILLED':
      changes = {
        is_absence_deduction_applicable: payload.data.data.absence_deduction_policy,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }

    case 'ABSENCE_CALCULATION_LOAD_FULFILLED':
    case 'ABSENCE_CALCULATION_UPDATE_FULFILLED':
      if (action.payload.data.message) {
        Toastr.success(action.payload.data.message)
      }
      changes = {
        absence_calculation: payload.data.data.payrun_configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
        absence_calculation_fetching: false,
      }
      return { ...state, ...changes }

    case 'VACATION_CALCULATION_LOAD_FULFILLED':
    case 'VACATION_CALCULATION_UPDATE_FULFILLED':
      changes = {
        vacation_calculation: payload.data.data.configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }

    case 'UNPAID_CALCULATION_LOAD_FULFILLED':
    case 'UNPAID_CALCULATION_UPDATE_FULFILLED':
      changes = {
        unpaid_calculation: payload.data.data.organization_configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }

    case 'LOAN_LIMIT_LOAD_FULFILLED':
      changes = {
        loan_limit: payload.data.data.payrun_configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }
    case 'LOAN_LIMIT_UPDATE_FULFILLED':
      Toastr.success(action.payload.data.message)
      changes = {
        loan_limit: payload.data.data.payrun_configuration,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }
    case 'LOAN_LIMIT_BULK_UPDATE_FULFILLED':
      Toastr.success(action.payload.data.message)
      changes = {
        bulk_payrun_configurations: payload.data.data,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
        loading: false,
      }
      return { ...state, ...changes }

    default:
      return state
  }
}
